module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2ct",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER ONE")]), _c('br'), _c('br'), _vm._v("COLLECTING BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("One of my prized possessions: the first book I ever bought,")]), _vm._v(" Wide Awake. "), _c('em', [_vm._v("I was four.")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("We all know the standard interior decorating practice of adding a mirror to make a room appear larger. Books are mirrors of a different kind; they reflect our values, our thoughts, and what we hold dear, adding another type of breadth to a room. Though books literally (and, well . . . literally) heighten the scope and vitality of a space, they are not merely a decorative device. Likewise, a library is more than just a physical place—it is a space that tells a story. In fact, a bookshelf is readable in and of itself; as though reading a page, your eyes move along the spines as you conjure impressions. Look at friends’ bookshelves and you’ll get a deeper understanding of who they are and, most likely, you will see some of the same titles that you own. This chapter explores the ins and outs of collecting and sourcing books to build your own personal library, or to shape one you might have already, and how the books you choose to collect and display breathe life into your home.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("COLLECTING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A library is a collection that is built book by book, and if you read or engage with the books you own, you most likely know your collection inside out and have a history with each volume. Every book, in its own way, has touched you, informed you—something not many inanimate objects can do. Books, no matter how many you have, create an environment of thoughtfulness because each one was acquired for its individuality and is treasured for that reason.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond reading them, we collect books as aesthetic objects. Their colored, rectangular (and sometimes square) shapes are works of art. Though they are sturdy, rigid forms, they are composed of soft, supple materials: paper, cloth, glue, thread, and ink. Enjoying a book is as much a tactile experience (feeling the fabric of the cover, the edges of the pages, or an embossed signet or title) as it is a visual experience (taking in the various typography styles, illustrations, and design elements).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though popular and convenient, e-readers tend to eliminate the tactile experience of the book, reducing it solely to its content, which is only part of what a book is. With the advent and proliferation of e-readers, I consider book collecting a form of rescuing. I fear an era in which a book is something a generation has only heard about, or seen an image of on their screens. It is up to us to safeguard books, honor them, cherish them, engage our children with them, and live with them, not as treasures so precious they are kept beneath lock and key, but as objects in daily use. In this way, they become part of our personal histories, which contributes to a broader cultural collective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Collecting books is about gathering and adopting all that interests you, and anything that feels right in the home you continue to build, shape, and share. If you want to collect Harlequin Romance paperbacks from the 1970s and 1980s, go for it! There is no right or wrong way of going about it. But before you begin, it helps to consider what and how you collect, which will only make the hunting and gathering process richer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The simplest way to begin a collection is to decide upon a subject and then allow it to flourish. Whatever you find intriguing, whatever interests you, is the path to follow ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SEE SUBJECT IDEAS ON "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01#page_18"
    }
  }, [_vm._v("THIS PAGE")])]), _vm._v("). Because books are a magnification and expansion of our inner selves, collecting is a highly personal and subjective endeavor and an extension of our personal interests. There are no rules when it comes to collecting books; in fact, the more arcane the better. And because you are physically building something—a library—book by book, it is emotionally and intellectually rewarding and viscerally satisfying. It can also become wickedly addictive—a condition called "), _c('em', [_vm._v("bibliomania")]), _vm._v(", where books take over your life. But that is for another book entirely!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I bought my first book when I was four. I will never forget choosing it from a bin on a table in the downstairs, usually off-limits section of the public library where they were holding their book sale. I chose it because I liked its size and thickness, and I liked that it contained words and drawings in equal quantities. It might have cost a quarter but I would have paid a full dollar for it. Thus began my collecting.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("Evolution of the Book")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HANDWRITTEN SCROLL")]), _c('br'), _c('em', [_vm._v("first book form, made of parchment")])]), _vm._v(" "), _c('p', {
    staticClass: "image6"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CODEX")]), _c('br'), _c('em', [_vm._v("c.")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AD")]), _vm._v(" "), _c('em', [_vm._v("300–1500 covers are made of wood, pages are vellum")])]), _vm._v(" "), _c('p', {
    staticClass: "image6"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TYPESET PRINTED BOOK")]), _c('br'), _c('em', [_vm._v("c. 1500–present cloth and leather covered boards, pages are paper")])]), _vm._v(" "), _c('p', {
    staticClass: "image6"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captionc"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E-READER")]), _c('br'), _c('em', [_vm._v("c. 2000–present electronica, no physical materials")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Subject Ideas for Book Collecting")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('strong', [_vm._v("FICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Popular novels")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Mysteries")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Literature")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Graphic novels")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Science fiction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Poetry")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Children’s")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Westerns")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Thrillers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Drama")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Erotica")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('strong', [_vm._v("NONFICTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Artist monographs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Atlases")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Biographies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Cookbooks")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Dictionaries")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Fashion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Instruction manuals")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Letters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Music")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Religion")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Science")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Sports")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('strong', [_vm._v("HISTORICAL PERIODS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Ancient Greece")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Middle Ages")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Renaissance")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Belle Époque")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Industrial Revolution")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Depression")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("American 1960s")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('strong', [_vm._v("TOPICS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("First editions")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Leather-bound novels")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Livres d’artistes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Foreign language")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Pop-ups")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Pulitzer Prize winners")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Anthologies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Bestsellers")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('strong', [_vm._v("MOVEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Romanticism")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Abolitionism")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Marxism")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Surrealism")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Existentialism")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Jungianism")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Women’s suffrage")]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("Civil Rights")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("COLLECTING FOR CONTENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Content is subject matter. It is the words in the book, the stories, ideas, and information expressed by the author. If you’re interested in content, you’ll be apt to collect an author’s entire oeuvre, or a grouping of, say, Caldecott Medal winners. You might build an entire collection on a particular subject area such as gardening or Beat poets or tribalism. You might have more than one copy of a title because there could be an added preface, an unabridged version, an updated edition. Or you might collect the same title in different languages. Like having a studio recording and a live version of the same album, having different versions broadens your collection and increases its merit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("As with any type of collecting, once you begin a path, it bifurcates. You might start by collecting books by nineteenth-century poets, then learn that one of the authors on your shelf also wrote novels, taking you down a whole new trail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When content is the basis for your collecting you might ask, why pay more money for an earlier edition of the same title when you can buy a new version for less money? It is valuable to buy that earlier edition because it brings you closer to the author, nearer to the genesis of the work. Perhaps the author worked with this publisher in person, agreeing on the design or format. Perhaps the copy is signed by the author. These elements add distinction to your collection.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("COLLECTING FOR FORM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Collectors have always been concerned with the book’s physical beauty. Up into the eighteenth century, books were often sold unbound so customers could select personalized bindings, choosing colors and materials or incorporating a family crest. Because of this, bookbinders were often permanent workers at bookshops. It wasn’t until the early nineteenth century, with the arrival of metal printing presses and mass-produced paper, that the publisher began to take responsibility for the acquiring, editing, printing, and binding as one enterprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A book’s form is the book as a physical object, its pages and covers, the materials used in its construction (vellum, parchment, paper), the style of binding, the typography. These are also indicators of the time in which it was printed and bound, not necessarily when it was written. For instance, Shakespeare wrote in the late 1500s but his works have been published ever since. So a copy of "), _c('em', [_vm._v("The Merchant of Venice")]), _vm._v(" woodblock-printed on parchment and bound in hand-tooled leather covers with gilt work has a very different physical history (and obviously financial value) from that of an Oxford’s World Classic copy of "), _c('em', [_vm._v("The Merchant of Venice")]), _vm._v(" printed twenty years ago. The content is the same, but the physical form is different. A book’s binding is the historical vehicle for the content. It reflects its era of production and contributes to its value.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you’re interested in the form of the book, you might be less concerned with what they are about; reading them is ancillary. Perhaps you are drawn to "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("collecting books with elaborately decorated spines (making for a beautiful length of shelf). Those searches might splinter into books with titles on their decorative spines, and others with "), _c('em', [_vm._v("only")]), _vm._v(" designs on them. You might collect leather-bound tomes. Or hand-bound letterpress-printed books. Or pulp fiction paperbacks for their swarthy cover illustrations. Or maybe you buy only red hardbacks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am a collector of both content and form. I mostly collect hardcover books from the twentieth century, published between 1900 and 1970, fiction and nonfiction. I like that the signatures are often stitched rather than glued. I like the cloth used to cover the boards, and any cover details, like an illustration or typographic treatment, that reflect the era of its publication. I like colophons and frontispieces, bibliophilic details that are uncommon in printed books of today. As for content, I am interested in novels, art and photography books, children’s books, and biographies, though I am always looking for common books that are exceptions, like an illustrated copy of "), _c('em', [_vm._v("Gone with the Wind")]), _vm._v(" in German that I stumbled upon at my local library’s annual book sale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Part of my passion for book collecting is finding things within books: a note tucked into the pages, an inscription on a flyleaf, or marginalia from previous owners. For me, these are intriguing windows into the lives of people I will never meet, though we are now connected by the fact that our hands have held the same book. These are the stories beneath the ones printed on the pages, adding to the history and intimacy and, for me, the value of the book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Must collectors read all of the books they own? Not necessarily. I am a rigorous reader—reading is one of my absolute favorite things to do—but it is impossible to read every book I collect (though I do wish I had a clone who had the time and capacity to read each and every volume). You may not have time to read all the books in your library, but each book’s presence on your shelf is a totem of who you are at different times of your life.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0021-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("A midcentury German edition of")]), _vm._v(" Gone with the Wind"), _c('em', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0021-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Inscriptions connect us to books’ previous owners.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("SOURCING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now that you have decided on the types of books you would like to collect, the next step is to find and acquire them. Sourcing books is just as personal as determining your collection. The most obvious place to start looking is in your home. Go around your house and gather up all the books that are asunder, tucked in closets, stacked in corners, under beds, in boxes in the garage, or just settled in some heedless order. Once you bring them together you’ll start to see connections between them—color, size, subject matter, author, era—that might align with your defined collections.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The real fun begins, however, with search and discovery. This might mean literally going out into the field to find books, driving to a poorly lit book barn near the sea where the books are as high as the rafters, or finding an out-of-the-way bookshop whose owner is dustier than the ancient volumes on the shelves. It is a distinct experience that is part and parcel of the practice of collecting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Online shopping is an extraordinary tool and resource for the collector too. Not only can you locate a specific title, but you can purchase a book from anywhere in the world. There are times when I need specific books for an "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("artwork commission and because there is a deadline, the Internet comes in very handy. Obvious places to shop online are retailing sites such as Amazon and eBay. If your searches get more specific, you may try sites that specialize in rare, collectible, and out-of-print books, or in particular subjects. "), _c('a', {
    attrs: {
      "href": "http://Addall.com",
      "target": "_blank"
    }
  }, [_vm._v("Addall.com")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://Bookfinder.com",
      "target": "_blank"
    }
  }, [_vm._v("Bookfinder.com")]), _vm._v(" are comprehensive sites dedicated to books, while the Antiquarian Booksellers’ Association of America has a broader reach. Because the ABAA site is by and for the professional book dealer trade, it is not only great for sourcing but is also rife with collector and conservator information, plus it will give you a look into the idiosyncratic culture of book collecting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, I prefer sourcing in person. Whatever the book may be, I like to see it for myself and feel the materials in my hands in order to decide whether or not I want to own it. I love trawling secondhand bookstores, yard sales, thrift shops, and flea markets, and I am all about the thrill of the hunt, finding a gem at the bottom of a box at a garage sale, or amid a ragtag stack on a table at a flea market. Since negotiation is typically easier to do in person, this type of sourcing will often get you better deals—especially if you’re buying several volumes—plus there are no shipping fees.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("Websites for Sourcing Books for your Collections")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://ABAA.org",
      "target": "_blank"
    }
  }, [_vm._v("ABAA.org")]), _vm._v(" (Antiquarian Booksellers’ Association of America)"), _c('br'), _vm._v("A thorough site for book collecting standards, as well as a resource for book fairs, articles on collecting, and helpful FAQs.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://ABEBOOkS.com",
      "target": "_blank"
    }
  }, [_vm._v("ABEBOOKS.com")]), _c('br'), _vm._v("A subsidiary of Amazon since 2008, their rare and collectible arm.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://ADDALL.com",
      "target": "_blank"
    }
  }, [_vm._v("ADDALL.com")]), _c('br'), _vm._v("An independent marketplace that searches books at forty-one online bookstores to get the best books for the best price.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://ALIBRIS.com",
      "target": "_blank"
    }
  }, [_vm._v("ALIBRIS.com")]), _c('br'), _vm._v("Search the Rare and Collectible sections, and get information on condition, repair, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://AMAZON.com",
      "target": "_blank"
    }
  }, [_vm._v("AMAZON.com")]), _c('br'), _vm._v("Best for more current books. For more collectible versions, do an advanced search and click on “collectible” under condition.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://BIBLIO.com",
      "target": "_blank"
    }
  }, [_vm._v("BIBLIO.com")]), _c('br'), _vm._v("Search and purchase books globally, and locate independent bookstores anywhere in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://BOOKFINDER.com",
      "target": "_blank"
    }
  }, [_vm._v("BOOKFINDER.com")]), _c('br'), _vm._v("An e-commerce site directly partnered with 150,000 booksellers worldwide; great for price comparisons.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://COOKBOOKERY.com",
      "target": "_blank"
    }
  }, [_vm._v("COOKBOOKERY.com")]), _c('br'), _vm._v("Specializes in all cookbooks, especially vintage.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://CRAIGSLIST.org",
      "target": "_blank"
    }
  }, [_vm._v("CRAIGSLIST.org")]), _c('br'), _vm._v("Always worth a gander to see what is listed in books and free.")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('a', {
    attrs: {
      "href": "http://EBAY.com",
      "target": "_blank"
    }
  }, [_vm._v("EBAY.com")]), _c('br'), _vm._v("A huge flea market where you might find a gem for a steal. Always confirm the seller.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("BUDGETING")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Book collecting can be a highbrow, costly undertaking, but the type of collecting presented here is not so much about financial investment as it is a passionate, ongoing endeavor that serves as a testament to a life well lived, and as a preservation of books as cultural objects as we leave the analog age behind. One of the virtues of book collecting is that it is a respectable and accessible pursuit that can be done on any budget. While there are ways to determine the monetary value of books, the price or condition of a book may have no bearing on what it means to you and your collection. Some of your most cherished books might be ones that were given to you by someone you love, that originally belonged to a family member, that you purchased in a special place, or that you bought for a quarter when you were four. This is part of the subjective value of books, the individual stories they carry that only you know. For instance, I have a monograph on the painter Amadeo Modigliani that I bought at the iconic and historic Shakespeare and Company bookstore when I was a student in Paris. Every time it’s in my hands I am transported back to riding the Métro, meeting up with my drawing class, and smelling baking bread at every turn. In this way, books transcend time and place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That being said, it is no simple task to evaluate books. A friend of mine who has been a rare book dealer for thirty years described it to me as a supply/demand scenario: No matter what a book is or how beautiful it may be, if there is no market for it, it is not going to be worth as much as you might think. You’ll find that most books are affordable at well under $50. Books that run beyond $100 are very rare, historically valuable books or those produced in very small editions, like livres d’artistes ("), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SEE "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01#page_25"
    }
  }, [_vm._v("THIS PAGE")])]), _vm._v("). Even within a category of, say, important first editions of literature, for example, the price range is broad: T. S. Eliot’s "), _c('em', [_vm._v("The Waste Land")]), _vm._v(" (1922) is worth around $700, while F. Scott Fitzgerald’s "), _c('em', [_vm._v("The Great Gatsby")]), _vm._v(" (1925) fetches around $2,700.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you begin your hunt, set a budget that works for you. I typically do not spend more than $50 on a single book. I have no intention of re-selling the books I buy so I am not interested in profit margins or financial gain. I am "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("investing in my personal collection. When buying books online it is easy to compare sellers’ prices, and you will frequently find a wide range. Value and therefore pricing can be just as subjective as the act of collecting. The value is what the bookseller determines the price to be based upon their research on provenance and historical value (objective) and their personal assessments (subjective). So you want to be sure you’re paying a fair price no matter what you are buying. For instance, I researched the pricing on a book I own and found the majority of sellers of that same title, same publication date, and in similar condition, priced it around $16, though there were three sellers who had prices between $150 and $200 for the same exact book. Subjectivity is always a part of the equation. Bottom line: Pay what you are comfortable paying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides the historical importance and beauty of a book, rarity and condition are steadfast cost factors. Rarity is determined by how many copies of a particular edition exist—the fewer copies of a title in existence, the more costly it will be. As for condition, clearly, the less wear and tear a book has, the more it is worth. On "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01#page_27"
    }
  }, [_vm._v("this page")]), _vm._v(" are common distinctions used by booksellers, ordered from best to worst. There are also many increments sellers use to describe condition, such as "), _c('em', [_vm._v("extremely fine, near fine")]), _vm._v(", etc. Refer to "), _c('a', {
    attrs: {
      "href": "#/xhtml/ch01#page_26"
    }
  }, [_vm._v("this page")]), _vm._v(" for these and other abbreviations that sellers use in their online listings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then there is the windfall. Once people know you are a bibliophile, they will offer you boxes and bags and bundles of books they need to let go of. Before you load the books onto your shelves, make sure to consider each one and whether it fits into your collection (or is really of any interest to you at all). A little curating can go a long way toward preventing bibliomania!")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Livres d’Artistes")]), _vm._v(" "), _c('p', {
    staticClass: "boxn"
  }, [_c('em', [_vm._v("Livres d’artistes")]), _vm._v(", French for artists’ books, are deluxe-edition books made in very small quantities or sometimes only in an edition of one (called a one-off or unique book). Because they are limited editions, they are highly collectible and not something you’re likely to find at a book sale. When you collect artists’ books, you are acquiring art.")]), _vm._v(" "), _c('p', {
    staticClass: "boxi"
  }, [_vm._v("Livres d’artistes were incarnated in 1890s Paris, conceptualized and produced by the gallerists Ambroise Vollard and Daniel-Henry Kahnweiler to serve a middle-class market, and have become a specialized and thriving art form.")]), _vm._v(" "), _c('p', {
    staticClass: "boxi"
  }, [_vm._v("They are not simply illustrated books but collaborations between artist and writer, and oftentimes with printers, designers, binders, and dealers. Exquisitely crafted books, they incorporate fine binding and are mostly, if not always, handmade, and often employ nontraditional and/or rare materials. They are frequently letterpress-printed and bound in the form of a traditional book, but can also be conceptual and sculptural in nature and construction.")]), _vm._v(" "), _c('p', {
    staticClass: "boxi"
  }, [_vm._v("The distinction of artists’ books is that they are not simply loose pages grouped together and bound into a single form; rather the entire form of the book is considered as a whole. The style of binding and the choice of materials are intentional and relate to the book’s theme. Their form and content are not exclusive of each other but symbiotic.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0025-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Artist and friend Wilfredo Chiesa collaborated with a poet and a musician to create this limited-edition artist book.")]), _vm._v(" Relatos de un Paisaje Asesinado "), _c('em', [_vm._v("(")]), _vm._v("Recounts of an Assassinated Landscape"), _c('em', [_vm._v(") 11 × 15 × 1.5\" (28 × 38 × 4 cm) closed/22 × 15\" (56 × 38 cm) open, 1978. Book design, art, and binding by Wilfredo Chiesa, poetry by Tomás López Ramirez, music by Rafael Aponte-Ledée.")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Common Descriptive Abbreviation Used by Booksellers")]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("A.MS.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("autographed manuscript")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("BCC.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("book club edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("BDG.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("binding")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("BKPL")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("bookplate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("CL.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("cloth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("CPY.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("copy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("CV.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("cover")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("DISB.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("disbound")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("D-J")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("dust jacket")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("ED.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("edition, editor, edited")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("EDN.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("E.F.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("extremely fine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("E.P.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("endpapers")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("F.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("fine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("F/O")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("fold out")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("FRONT.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("frontispiece")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("FX.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("foxing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("G.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("good")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("H.C.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("hardcover")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("ILL.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("illustrated, illustrations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("INSCR.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("inscribed, inscription")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("M.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("mint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("MS.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("manuscript")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("MSSG")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("missing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("N.D.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("no publishing date")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("N.F.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("near fine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("O.P.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("out of print")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("O/W")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("otherwise")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("P.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("poor")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("PB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("paperback")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("PP.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("pages")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("PL.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("illustration plate")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("REPRD.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("repaired")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("REV.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("revised")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("S.C.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("softcover")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("SGD.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("signed")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("SLPCS.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("slipcase")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("STNS.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("stains")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("SWD.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("sewed")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("T.E.G.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("top edges gilt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("UNB.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("unbound (loose pages)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("V.F.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("very fine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("V.G.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("very good")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("WN.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("worn")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("WR.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "boxn"
  }, [_vm._v("wrapper (dust jacket)")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("Book Collection Guide")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("MINT")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("An absolute perfect copy, like new, and in the same condition as the day it was published/made; if it was issued with a dust jacket, the jacket should be without any tears, flaws, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("FINE")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("A book with no damage; in older books: only minor flaws from little usage; bindings should still be crisp; if there is a dust jacket, only small tears or stains should appear.")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("VERY GOOD")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("A book with few and minor signs of wear on either the binding or the pages, but no tears; no longer pristine but still collectible. For many collectors, this is the minimum acceptable condition. Any defects must be noted by the seller.")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("GOOD")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("A used book with all of its pages intact. It is worn yet complete and might have such infractions as highlighted text, loose bindings, a torn dust jacket, or bent corners. Any defects must be noted by the seller.")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("FAIR")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("A very worn, much-handled book with all its pages present, though endpapers or a title page may be missing. There might be markings, but they do not hinder readability. Any defects must be noted by the seller.")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("POOR")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("A book that is extremely worn but does have all of its text pages and is still readable, though it may be missing maps or illustrated pages. It may be stained, spotted, scuffed, and/or have loose bindings or pages. Any defects must be noted by the seller. Reading copies fall into this group.")]), _vm._v(" "), _c('p', {
    staticClass: "boxc"
  }, [_vm._v("READING COPY")]), _vm._v(" "), _c('p', {
    staticClass: "boxbq"
  }, [_vm._v("A used book that is worn to such a degree that it is not in good enough condition to be considered collectible. Any defects must be noted by the seller."), _c('a', {
    attrs: {
      "id": "page_28"
    }
  })])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 72
// module chunks = 0